import { combineReducers } from "redux-immutable";

import LocationsStateSlice from "../models/LocationsStateSlice";
import locations from "./state/locations";
import locationsMetaReducer from "./state/meta";

const locationsReducer = combineReducers(
  {
    locations,
    meta: locationsMetaReducer
  },
  () => new LocationsStateSlice() as any
);

export default locationsReducer;
